"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        title: {
            marginLeft: theme.spacing(2),
        },
        subtitle: {
            marginTop: '5px',
            marginLeft: '15px',
            color: themes_1.materialColors.grey[500],
            // ASK: is all of this necessary?
            fontFamily: 'Inter',
            fontSize: '12px',
            lineHeight: '1.33',
            textAlign: 'left',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            letterSpacing: 'normal',
        },
        appBar: {
            position: 'relative',
        },
        buttons: {
            '& > *': {
                marginLeft: theme.spacing(1),
            },
        },
    });
});
